import React, {ChangeEvent} from "react";
import TextArea from "antd/es/input/TextArea";
import {Input, Tabs} from "antd";
import {connect} from "react-redux";
import {getTranslate, TranslateFunction} from "react-localize-redux";
import dayjs from "dayjs";
import Announcement from "../Announcement/Announcement";
import {JobItem} from "../JobItem/JobItem";
import {
    claimJobPhase, completeJobPhase, getJobPhaseWorkflowDefinitions, showConfirmClaimDialog,
} from "../../store/actions/job";
import {JobEntity} from "../../interfaces/store/actions/payload/job";
import {TaskDetails} from "../JobDrawer/TaskDetails/TaskDetails";
import StoreState from "../../interfaces/store/storeState";
import "./MarkdownPreview.scss";

interface Props {
    translate: TranslateFunction
}

interface State {
    jobDescription: string
    announcementHeadline: string
    announcementPicture: string
    announcementIntroduction: string
    announcementContent: string
}

class MarkdownPreview extends React.Component<Props, State> {
    private static readonly translationPath: string = "components.NavigationBar.NavigationBar";

    state = {
        jobDescription: "",
        announcementHeadline: "",
        announcementPicture: "",
        announcementIntroduction: "",
        announcementContent: "",
    };

    constructor(props: Props) {
        super(props);

        this.updateJobDescription = this.updateJobDescription.bind(this);
        this.updateAnnouncementHeadline = this.updateAnnouncementHeadline.bind(this);
        this.updateAnnouncementPicture = this.updateAnnouncementPicture.bind(this);
        this.updateAnnouncementIntroduction = this.updateAnnouncementIntroduction.bind(this);
        this.updateAnnouncementContent = this.updateAnnouncementContent.bind(this);
    }

    updateJobDescription({target: {value}}: ChangeEvent<HTMLTextAreaElement>) {
        this.setState({jobDescription: value});
    }

    updateAnnouncementHeadline({target: {value}}: ChangeEvent<HTMLInputElement>) {
        this.setState({announcementHeadline: value});
    }

    updateAnnouncementPicture({target: {value}}: ChangeEvent<HTMLInputElement>) {
        this.setState({announcementPicture: value});
    }

    updateAnnouncementIntroduction({target: {value}}: ChangeEvent<HTMLTextAreaElement>) {
        this.setState({announcementIntroduction: value});
    }

    updateAnnouncementContent({target: {value}}: ChangeEvent<HTMLTextAreaElement>) {
        this.setState({announcementContent: value});
    }

    render() {
        const {
            jobDescription,
            announcementHeadline,
            announcementPicture,
            announcementIntroduction,
            announcementContent,
        }: State = this.state;
        const {translate}: Props = this.props;

        const jobMock: JobEntity = {
            assignee: "",
            stopped: true,
            open: true,
            started: true,
            name: "Annotation",
            projectType: "ANNOTATION",
            title: "Transcription Training (English)",
            description: jobDescription,

            assignmentType: "MOCK",
            id: "MOCK",
            jobId: "MOCK",
            projectId: "MOCK",
            status: "MOCK",
            workflowDefinitionId: "MOCK",
            idx: 1,
            taskCount: 1,
            version: 1,
            tags: [],
            phaseStats: {},
            taskStats: {
                NEW: 1,
                IN_PROGRESS: 1,
                COMPLETED: 1,
                REJECTED: 1,
            },
            // cloneCount?: number
            // cloneLimit?: number
            // dueDate?: number
            // projectManager?: string
            // userCloneLimit?: number
            // rejectedTaskCount?: number
            // userCloneCount?: number
            // completedTaskCount?: number
            // estimatedTime? : number
            // featured?: boolean
        };

        return (
            <Tabs className="df-markdown-preview">
                <Tabs.TabPane
                    tab="Job (card and details side panel)"
                    key="job"
                >
                    <TextArea
                        value={jobDescription}
                        placeholder="Input job description markdown here"
                        onChange={this.updateJobDescription}
                    />
                    <div
                        className="df-job-preview-wrap"
                    >
                        <JobItem
                            editors={{}}
                            phaseConfigList={{
                                "ANNOTATION-Annotation": {
                                    auto: false,
                                    claimEnabled: false,
                                    editor: "annotation",
                                    enableBulkCompletePhaseAction: false,
                                    id: "MOCK",
                                    name: "Annotation",
                                    projectType: "ANNOTATION",
                                    version: 1,
                                },
                            }}
                            workflowDefinitionList={[]}
                            translate={translate}
                            isMobile={false}
                            activeJobType="a"
                            claimJobPhase={claimJobPhase}
                            completeJobPhase={completeJobPhase}
                            showConfirmClaimDialog={showConfirmClaimDialog}
                            getJobPhaseWorkflowDefinitions={getJobPhaseWorkflowDefinitions}
                            data={jobMock}
                            hideBtnDropdown
                            appStoreUrl="mockUrl"
                            playStoreUrl="mockUrl"
                        />
                        <div className="df-spacer"/>
                        <div className="df-task-details-wrapper">
                            <Tabs
                                type="card"
                            >
                                <TaskDetails
                                    tab="Details"
                                    data={jobMock}
                                    activeJobType=""
                                    translate={translate}
                                />
                            </Tabs>
                        </div>
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Announcement" key="announcement" className="df-markdown-preview-announcement">
                    <Input
                        value={announcementHeadline}
                        placeholder="Input Headline text here"
                        onChange={this.updateAnnouncementHeadline}
                    />
                    <Input
                        value={announcementPicture}
                        placeholder="Input Image url here (optional)"
                        onChange={this.updateAnnouncementPicture}
                    />
                    <TextArea
                        value={announcementIntroduction}
                        placeholder="Input Introduction (brief text) markdown here"
                        onChange={this.updateAnnouncementIntroduction}
                    />
                    <TextArea
                        value={announcementContent}
                        placeholder="Input Content (full text) markdown here"
                        onChange={this.updateAnnouncementContent}
                    />
                    <div className="df-task-announcement-wrapper">
                        <Announcement data={{
                            Headline: announcementHeadline,
                            Picture: announcementPicture,
                            Introduction: announcementIntroduction,
                            Content: announcementContent,
                            Date: dayjs()
                                .format("d-MMM-YY"),
                        }}
                        />
                    </div>
                </Tabs.TabPane>
            </Tabs>
        );
    }
}

function mapStateToProps(state: StoreState): Props {
    return {
        translate: getTranslate(state.localize),
    };
}

export default connect(mapStateToProps)(MarkdownPreview);
